<div class="flex flex-column lg:flex-row gap-3">
  <div class="flex-1">
    <div class="formgrid grid pt-3">
      <div class="field col-6 lg:col-4">
        <label class="text-gray-400">{{'PLAYER_NUMBER' | translate}}</label>
        <div class="pt-2">
          {{playerProfile.playerNumber}}
        </div>
      </div>
      <div class="field col-6 lg:col-4">
        <label class="text-gray-400">{{'PASSWORD' | translate}}</label>
        <div>
          <p-button [label]="('CHANGE_PASSWORD' | translate) + '...'"
                    styleClass="p-button-text" icon="pi pi-key" (click)="changePassword()"/>
        </div>
      </div>

      <div class="field col-6 lg:col-4">
        <label class="text-gray-400">{{'CONTACT_EMAILADDRESS' | translate}}</label>
        <div class="flex align-items-center">
          {{playerProfile.account?.mail}}
          <p-button styleClass="p-button-text" icon="pi pi-pencil"
                    [pTooltip]="'CHANGE_MAIL_ADDRESS' | translate" [showDelay]="400" tooltipPosition="left"
                    (click)="changeMailAddress()"/>
        </div>
      </div>

      <div class="field col-6 lg:col-4">
        <label class="text-gray-400">{{'LANGUAGE' | translate}}</label>
        <div>
          <app-language-dropdown [(selectedLanguage)]="playerProfile.languageCd"
                                 (languageChange)="updatePlayerProfileValue({ 'languageCd': playerProfile.languageCd}, undefined)"/>
        </div>
      </div>

      <div class="field col-12 lg:col-8">
        <label class="text-gray-400">{{'ACCOUNT_STATUS' | translate}}</label>
        <div class="flex pt-2">
          <app-player-profile-payment-status [playerProfile]="playerProfile" [longStatus]="true" [buttonGotoPayment]="true"/>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="profile-image-box relative" [pTooltip]="('UPLOAD_IMAGE' | translate) + '...'" [showDelay]="400"
         (click)="selectPlayerImage()">
      @if (playerProfile.pictureUrl) {
        <img [src]="playerProfile.pictureUrl">

        <div class="absolute right-0 bottom-0">
          <p-button icon="pi pi-trash"
                    styleClass="p-button-rounded p-button-text p-button-danger"
                    [pTooltip]="'REMOVE' | translate"
                    (click)="deletePlayerImage($event)"/>
        </div>
      } @else {
        <i class="pi pi-user"></i>
      }
    </div>
  </div>
</div>

@if (playerProfile?.pictureInactive) {
  <div class="py-2">
    <app-info-text [text]="'PLAYER_PROFILE_IMAGE_BLOCKED_TEXT' | translate: {value: playerProfile.pictureInactiveText}"
                   [warningFrontend]="true"/>
  </div>
}

<div class="pt-2 md:pt1">
  <p-button icon="pi pi-cog"
            styleClass="p-button-rounded p-button-text"
            [label]="('SETTINGS' | translate) + ' (' + ('NOTIFICATIONS' | translate) + ')'"
            (click)="openSettings()"/>
</div>

<p-divider/>

@if (system() !== 'ios') {
  <p-button styleClass="p-button-text" icon="pi pi-lightbulb" size="small"
            [label]="'PLAYER_PROFILE_FEATURES' | translate"
            [disabled]="isLoggingOut" [loading]="isLoggingOut"
            (click)="openPlayerProfileFeatures()"/>
  <p-divider/>
}

<div class="pt-2 md:pt1">
  <p-button icon="pi pi-sign-out"
            styleClass="p-button-rounded p-button-text"
            [label]="'LOGOUT' | translate"
            (click)="logout()"/>
</div>
<p-divider/>

<p-button styleClass="p-button-text p-button-danger" icon="pi pi-trash"
          [label]="('DELETE_PLAYER_PROFILE' | translate) + '...'"
          [disabled]="showDeletePlayerProfileDetails"
          (click)="showDeletePlayerProfileDetails = true"/>

@if (showDeletePlayerProfileDetails) {
  <div class="pt-2 text-base">
    {{ 'DELETE_PLAYER_PROFILE_MSG' | translate }}
  </div>
  <div class="pt-2 text-base">
    {{ 'DELETE_PLAYER_PROFILE_MSG2' | translate }}
  </div>
  <div class="py-2">
    <p-password [(ngModel)]="playerProfilePasswordDelete" [fluid]="true" [disabled]="isDeleting"
                styleClass="p-password-input p-password p-component p-inputwrapper p-input-icon-right"
                class="grid-comp-full-width" [feedback]="false" [toggleMask]="true"/>
  </div>
  <p-button styleClass="p-button-text p-button-danger" icon="pi pi-trash"
            [label]="('DELETE_PLAYER_PROFILE_FINALLY' | translate)"
            [disabled]="isDeleting || !playerProfilePasswordDelete" [loading]="isDeleting"
            (click)="deletePlayerProfile()"/>
}

<!--@if (!playerProfile?.hidePayments) {
  <app-player-profile-features [onlyFeatures]="true"/>
}-->

@if (showDebug ||
     playerProfile?.playerNumber === 'DART' ||
     playerProfile?.playerNumber === 'CK81' ||
     playerProfile?.playerNumber === 'BREV' ||
     playerProfile?.playerNumber === '6DYX' ||
     playerProfile?.playerNumber === '88T9') {
  <p-divider/>
  <h3>Debug Data</h3>
  <div [innerHTML]="flutterService.debugStr"></div>
}
